export default __webpack_public_path__ + "static/media/mpost.b5a396ec.jpg";